/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable no-undef */
import React from "react"
import cheerio from "cheerio"
import { Header } from "../../components/common"
import Helmet from "react-helmet"
import { useStaticQuery, Link } from "gatsby"
import Img from "gatsby-image"

export default props => {
  // const html = cheerio.load(props.post.html)

  const divHtml = cheerio.load(props.post.html)
  divHtml(`ul`).addClass(`p-list pb-4`)
  divHtml(`p`).addClass(`pb-5`)
  divHtml(`img`).addClass(`text-center m-auto pb-5`)
  divHtml(`img`).attr("alt", props.post.title + " related")
  divHtml(`img`).attr("title", props.post.title)
  divHtml(`img`).map((i, el) => {
    const newUrl = el.attribs["src"].replace(
      "http://",
      "https://"
    )
    el.attribs["src"] = newUrl

  })

  // const url = html(`img`)
  //   .attr("src")
  //   .replace("http://", "https://")
  // html(`img`).attr("src", url)
  // const img = html(`img`).attr("src")

  const data = useStaticQuery(graphql`
    query {
      getNavigation: file(
        relativePath: { eq: "baseline_navigate_next_black_24dp.png" }
      ) {
        ...imageQuery
      }
    }
  `)
  return (
    <main role="main" className="storyDetails">
      <Helmet>
        <title>{`News | ${props.post.title
          .split(" ")
          .splice(0, 5)
          .join(" ") + "..."}`}</title>
        <meta name="description" content={props.post.excerpt}></meta>
        <meta name="twitter:title" content={props.post.title}></meta>
        <meta property="og:title" content={props.post.title}></meta>
        <meta name="og:description" content={props.post.excerpt}></meta>
        <meta name="twitter:description" content={props.post.excerpt}></meta>
        <meta name="twitter:card" content={props.post.excerpt}></meta>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        <meta
          name="twitter:url"
          content={`https://www.tarento.com/${props.post.url.split("/")[3]}/`}
        ></meta>
        <meta
          property="og:url"
          content={`https://www.tarento.com/${props.post.url.split("/")[3]}/`}
        ></meta>
        <meta property="og:image" content={props.post.feature_image}></meta>
        <meta name="twitter:image" content={props.post.feature_image}></meta>
        <meta name="twitter:site" content={props.post.title}></meta>
        <link
          href={`https://www.tarento.com/${props.post.url.split("/")[3]}/`}
          rel="canonical"
        />
      </Helmet>
      <Header />
      {/* <section className="layout">
         
        </section> */}
      <section className="mt-4">
        <div className="container">
          <div className="row">
            <div className="col-md-9 m-auto">
              <div className="row mb-3 pl-0 ml-0">
                <Link to="/news/" className="link-underline">
                  <label className="breadcumb-1 pt-3">&nbsp;News</label>
                </Link>
                <div className="navigate-1 pt-3">
                  <Img
                    className=""
                    fluid={data.getNavigation.childImageSharp.fluid}
                    alt="navigate"
                  />
                </div>
                <label className="breadcumb-1 pt-3">{props.post.title}</label>
              </div>
              <div className="storyCard">
                <h1 className="h4 h2LS original-text pb-3">
                  {props.post.title}
                </h1>
                <div dangerouslySetInnerHTML={{ __html: divHtml.html() }}></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
